export default "__VITE_ASSET__PibAnf_w__"